import { Pipe, PipeTransform, Inject, Optional } from '@angular/core';

@Pipe({
    name: 'noComma'
})
export class NoCommaPipe implements PipeTransform {
    private delimiter;

    constructor(@Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.language === 'es') {
            this.delimiter = '.';
        } else {
            this.delimiter = '/,/g';
        }
    }
    transform(val: string): string {
        if (val !== undefined && val !== null) {
            return val.toString().replace(this.delimiter, '');
        } else {
            return '';
        }
    }
}
